import React from 'react';

import BasicInfo from './Partials/basicinfo';
import ChangePassword from './Partials/changepswrd';
import StaffInfo from './Partials/staffinfo';
import Utils from '../../lib/utils';

import './index.scss';

class Conversations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle: false,
      modalopen: false,
      showsucess: false,
      showfailure: false,
      admin: false,
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      currentpasswrod: '',
      password: '',
      repassword: '',
      unequalpassword: false,
      oldpassworderror: false,
      errors: [],
      passwordupdatesuccess: false,
      passwordupdatefailure: false,
      businessNameUpdatesuccess: false,
      businessNameUpdatefailure: false,
    };
    this.conversationslist = [];
  }

  componentDidMount() {
    let admin = false;
    if (
      this.props.business &&
      this.props.business.clientUser &&
      this.props.business.clientUser.role === 'ADMIN'
    ) {
      admin = true;
      this.setState({
        firstName: this.props.business.clientUser.firstName,
        lastName: this.props.business.clientUser.lastName,
        email: this.props.business.clientUser.email,
        phone: this.props.business.clientUser.phone,
        admin,
      });
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps != this.props) {
      let admin = false;
      if (
        nextProps.business &&
        nextProps.business.clientUser &&
        nextProps.business.clientUser.role === 'ADMIN'
      ) {
        admin = true;
      }
      this.setState({
        firstName: nextProps.business.clientUser.firstName,
        lastName: nextProps.business.clientUser.lastName,
        email: nextProps.business.clientUser.email,
        phone: nextProps.business.clientUser.phone,
        admin,
      });
    }
    if (
      this.props.staffManagement.updatinginfo === true &&
      nextProps.staffManagement.updatinginfo === false
    ) {
      if (nextProps.staffManagement.infoupdated === true) {
        this.setState({
          showsucess: true,
        });
        setTimeout(() => {
          this.setState({
            showsucess: false,
          });
        }, 3000);
      } else {
        this.setState({
          showfailure: true,
        });
        setTimeout(() => {
          this.setState({
            showfailure: false,
          });
        }, 3000);
      }
    }
    if (
      this.props.staffManagement.updatingpassword === true &&
      nextProps.staffManagement.updatingpassword === false
    ) {
      if (nextProps.staffManagement.passwordupdated === true) {
        this.setState({
          passwordupdatesuccess: true,
        });
        setTimeout(() => {
          this.setState({
            passwordupdatesuccess: false,
          });
        }, 3000);
      } else {
        this.setState({
          passwordupdatefailure: true,
        });
        setTimeout(() => {
          this.setState({
            passwordupdatefailure: false,
          });
        }, 3000);
      }
    }
    if (
      this.props.business.updatingBusinessName === true &&
      nextProps.business.updatingBusinessName === false
    ) {
      if (nextProps.business.updateBusinessNameSuccess === true) {
        this.setState({
          businessNameUpdatesuccess: true,
        });
        setTimeout(() => {
          this.setState({
            businessNameUpdatesuccess: false,
          });
        }, 3000);
      } else {
        this.setState({
          businessNameUpdatefailure: true,
        });
        setTimeout(() => {
          this.setState({
            businessNameUpdatefailure: false,
          });
        }, 3000);
      }
    }
  }
  removeArrayElement = (array, element) => {
    const index = array.indexOf(element);
    if (index > -1) {
      array.splice(index, 1);
    }
    return array;
  };
  onUpdateInfoChange = (event, target) => {
    let errors = [...this.state.errors];
    let oldpassworderror = false;
    let unequalpassword = false;
    if (target === 'firstName') {
      if (event.target.value && event.target.value.trim().length > 0) {
        errors = this.removeArrayElement(errors, 'firstName');
      } else {
        if (errors.indexOf('firstName') == -1) errors.push('firstName');
      }
    }

    if (target === 'lastName') {
      if (event.target.value && event.target.value.trim().length > 0) {
        errors = this.removeArrayElement(errors, 'lastName');
      } else {
        if (errors.indexOf('lastName') == -1) errors.push('lastName');
      }
    }

    if (target === 'email') {
      console.log('email', Utils.isValidEmail(event.target.value));
      if (
        event.target.value.length < 1 ||
        !Utils.isValidEmail(event.target.value)
      ) {
        if (errors.indexOf('email') == -1) errors.push('email');
      } else {
        errors = this.removeArrayElement(errors, 'email');
      }
    }

    if (target === 'phone') {
      console.log('phone', Utils.isValidEmail(event.target.value));
      if (
        event.target.value.length < 1 ||
        !Utils.isValidPhone(event.target.value)
      ) {
        if (errors.indexOf('phone') == -1) errors.push('phone');
      } else {
        errors = this.removeArrayElement(errors, 'phone');
      }
    }
    if (target === 'currentpasswrod') {
      if (event.target.value && event.target.value.trim().length > 0) {
        oldpassworderror = false;
      } else {
        oldpassworderror = true;
      }
    }
    if (target === 'password') {
      if (
        event.target.value &&
        event.target.value.trim().length > 0 &&
        this.state.repassword === event.target.value
      ) {
        unequalpassword = false;
      } else {
        unequalpassword = true;
      }
    }
    if (target === 'repassword') {
      if (
        event.target.value &&
        event.target.value.trim().length > 0 &&
        this.state.password === event.target.value
      ) {
        unequalpassword = false;
      } else {
        unequalpassword = true;
      }
    }
    this.setState({
      [target]: event.target.value,
      errors,
      oldpassworderror,
      unequalpassword,
    });
  };

  onUpdateClick = () => {
    const { firstName, lastName, email, phone } = this.state;
    const params = {
      firstName: firstName,
      lastName: lastName,
      email: email,
      phone: phone,
    };
    this.props.updateStaffInfo(params);
  };

  onUpdatePasswordClick = () => {
    const {
      currentpasswrod,
      password,
      repassword,
      oldpassworderror,
    } = this.state;
    if (password != repassword || !currentpasswrod.trim().length > 0) {
      let unequalpassword = false,
        oldpassworderror = false;
      if (password != repassword) {
        unequalpassword = true;
      }
      if (!currentpasswrod.trim().length > 0) {
        oldpassworderror = true;
      }
      this.setState({
        unequalpassword,
        oldpassworderror,
      });
    } else {
      this.setState({
        unequalpassword: false,
        oldpassworderror: false,
      });
      const params = {
        old_password: currentpasswrod,
        password,
      };
      this.props.updateStaffPassword(params);
    }
  };

  disableUpdateIfo = () => {
    const { firstname, lastname, email, phone, role, errors } = this.state;
    if (
      firstname &&
      lastname &&
      email &&
      phone &&
      !this.props.staff.updatinginfo
    ) {
      if (
        firstname.trim().length > 0 &&
        lastname.trim().length > 0 &&
        email.trim().length > 0 &&
        phone.trim().length > 0
      ) {
        return false;
      }
    }
    return true;
  };
  
  saveBusinessName = (studio_name) => {
    const { auth, business } = this.props;
    const bzid = business?.id || auth?.studio_id;
    const param = {
      business_id: bzid,
      studio_name,
    }
    this.props.updateBusinessName(param);
  };
  
  render() {
    const {
      showsucess,
      showfailure,
      admin,
      currentpasswrod,
      password,
      repassword,
      unequalpassword,
      errors,
      passwordupdatesuccess,
      passwordupdatefailure,
      oldpassworderror,
      businessNameUpdatesuccess,
      businessNameUpdatefailure,
    } = this.state;
    //console.log()
    const { business, staffManagement, auth } = this.props;
    return (
      <div className="accountsettings">
        <div className="accountsettings_title">
          <div className="accountsettings_title_content">
            <span>Account Settings</span>
          </div>
          <div className="accountsettings_title_list">
            <div className="customization-list">
              <div className="customization-list_blocks">
              <StaffInfo
                auth={auth}
                business={business}
                saveBusinessName={this.saveBusinessName}
              />
              </div>
              {admin && (
                <div className="customization-list_blocks">
                <BasicInfo
                  info={business.clientUser}
                  onChange={this.onUpdateInfoChange}
                  onUpdateClick={this.onUpdateClick}
                  staffManagement={staffManagement}
                  disableUpdateIfo={this.disableUpdateIfo}
                  errors={errors}
                />
                </div>
              )}

            </div>
            <div className="customization-list">
              <ChangePassword
                currentpasswrod={currentpasswrod}
                password={password}
                repassword={repassword}
                unequalpassword={unequalpassword}
                staffManagement={staffManagement}
                onUpdateInfoChange={this.onUpdateInfoChange}
                onUpdatePasswordClick={this.onUpdatePasswordClick}
                oldpassworderror={oldpassworderror}
              />
            </div>
          </div>
          {(showsucess || passwordupdatesuccess || businessNameUpdatesuccess) && (
            <div className="copy-webhook">
              <span className="tick-mark">
                <i className="material-icons">check</i>
              </span>
              changes are updated.
            </div>
          )}
          {(showfailure || passwordupdatefailure || businessNameUpdatefailure) && (
            <div className="copy-webhook-failure">
              <span className="tick-mark">
                <i className="material-icons">close</i>
              </span>
              {staffManagement.error}.
            </div>
          )}
        </div>
      </div>
    );
  }
}
export default Conversations;
